<template>
  <div>
    <Titulo
      title="Remover Usuários"
      description="Remova Usuários em massa enviando a planilha"
    />
    <FormulateForm name="documentos" v-model="values" class="mt-5">
      <div class="clube-vantagens-upload row">
        <div class="col-md-3">
          <FormulateInput
            type="file"
            name="planilha"
            label="Planilha de Usuários"
            validation="mime:application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        </div>
        <div class="col-md-6">
          <div class="alert alert-warning w-100 mt-3 text-justify">
            Atenção! Para remover usuários em massa, você precisa seguir o
            padrão de arquivo disponível
            <a href="javascript:void(0)" @click="download">aqui para download</a
            >. Insira apenas os CPF(s) que deseja remover no arquivo, seguindo
            coluna "CPF" e envie no campo ao lado.
          </div>
        </div>
      </div>
      <div class="mt-3 alert alert-danger w-100" v-if="cpfInvalidos">
        Segue a lista de CPFs Inválidos encontrados no arquivo, verifique e
        tente novamente. O CPFs válidos, foram removidos com sucesso!
        <ul class="mt-2">
          <li v-for="(value, k) in cpfInvalidos" :key="k">- {{ value }}</li>
        </ul>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            @click="cancelar"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Enviar"
            :class="{ disabled: loading }"
            @click="!loading ? enviar() : ''"
            nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">ENVIANDO...</span>
            <span v-else>ENVIAR</span>
          </Botao>
        </div>
      </div>
    </FormulateForm>
  </div>
</template>
<script>
import Botao from "@/components/botoes/Botao";
import Titulo from "@/components/TituloPaginas";
export default {
  name: "FormEndereco",
  components: { Botao, Titulo },
  props: {
    tipoProduto: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      produto: {
        nome: "Clube de Vantagens",
        id: "Clube de Vantagens",
      },
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "Clube de Vantagens",
          link: "/produto/clube-vantagens/painel",
        },
        {
          nome: "Remover Usuários",
          id: "cancelamento",
          produto: "Clube de Vantagens",
        },
      ],
      values: {},
      loading: false,
      cpfInvalidos: null,
    };
  },
  methods: {
    cancelar() {
      this.$router.push({ name: "clube-painel" });
    },
    enviar() {
      this.loading = true;
      const form = new FormData();

      form.append("file", this.values.planilha.fileList[0]);

      this.$http
        .post(`/api/Clube/CancelarPlanilhaFuncionariosClubeVantagens`, form)
        .then((response) => {
          this.loading = false;
          if (response.status === 200) {
            if (response.data.cpfsInvalidos) {
              this.$toast.open({
                message: response.data.mensagem,
                type: "error",
                duration: 6000,
              });
              this.cpfInvalidos = response.data.cpfsInvalidos;
            } else {
              this.$toast.open({
                message: response.data.mensagem,
                type: "success",
                duration: 6000,
              });
              this.$router.push({ name: "clube-painel" });
            }
          }
        })
        .catch((error) => {
          console.error(error.response.data.mensagem);
          this.$toast.open({
            message: "Erro no envio dos seus arquivos, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
    download() {
      this.$http
        .get("/api/Clube/BuscarPlanilhaFuncionariosClubeVantagens")
        .then((response) => {
          var bin = atob(response.data.file.fileContents);
          var ab = this.s2ab(bin);
          let blob = new Blob([ab]);
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = response.data.file.fileDownloadName;
          link.click();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          }
          if (error.response.status === 400) {
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
            this.$router.push({ name: "agenda" });
          }
          this.loading = false;
        });
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
  },
  mounted() {},
  async created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.loading = false;
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.clube-vantagens-upload /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  @import "../../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
  input {
    padding: 5px 7px;
  }
  .formulate-input[data-type="radio"] {
    .formulate-input-element {
      display: flex;
      .formulate-input {
        margin-right: 7px;
        label {
          margin-left: 2px;
        }
      }
    }
  }
  .formulate-input[data-classification="textarea"] {
    textarea {
      background: white;
    }
  }
  .form-wrap {
    background: $dark-100;
    border-radius: 6px;
  }
}
.label {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
